import PropTypes from 'prop-types';
import { Form } from 'formik';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';

export const newLinkInviteSchema = Yup.object().shape({
});

const useStyles = makeStyles((theme) => ({
  generateButton: {
    margin: theme.spacing(2, 0)
  }
}));

const NewLinkInviteForm = ({ isSubmitting, disabled: formDisabled }) => {
  const classes = useStyles();
  const disabled = isSubmitting || formDisabled;
  // const errorsEnabled = submitCount > 0;
  return (
    <Form>
      <Button
        type="submit"
        margin="normal"
        disabled={disabled}
        variant="contained"
        color="primary"
        className={classes.generateButton}
      >
        Generate Invite Link
      </Button>
    </Form>
  );
};

NewLinkInviteForm.propTypes = {
  submitCount: PropTypes.number,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool
};

export default NewLinkInviteForm;
